import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Stack, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, ICONS, LinkUnstyled, unit } from '@hcr/ui'

import { SvgSwimRing } from '../../../../../assets/images'
import { Path } from '../../../../../models/navigation'
import { to } from '../../../../../utils/navigation'

interface RecommendSpaTileProps {
  destinationId: string
  serviceId: string
}

export const RecommendSpaTile: FC<RecommendSpaTileProps> = ({ destinationId, serviceId }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Button sx={{ padding: 0 }} component={LinkUnstyled} to={to([Path.ServiceDetails, { destinationId, serviceId }])}>
      <Tile>
        <TileInformation>
          <Stack direction={isDesktop ? 'row' : 'column'} spacing={0.5}>
            <TileTitle variant='headlineSTemporary'>{t('tickets.buy-spa-ticket')}</TileTitle>
            <TileTitle variant='headlineSTemporary'>{t('tickets.buy-spa-ticket-in-advance')}</TileTitle>
            <TileDescription variant='headlineSTemporary'>
              {t('tickets.buy-spa-ticket-for-a-lower-price')}
            </TileDescription>
          </Stack>
          <TileBuy>
            <TileBuyDescription variant='bodyMTemporary'>{t('tickets.buy-now')}</TileBuyDescription>
            <FontAwesomeIcon aria-hidden={true} icon={ICONS.farArrowRight} />
          </TileBuy>
        </TileInformation>
        <Image>
          <SvgSwimRing />
        </Image>
      </Tile>
    </Button>
  )
}

const Image = styled(Box)`
  margin-bottom: ${unit(3)};
`

const Tile = styled(Stack)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  background-color: ${COLORS.blue[500]};
`

const TileInformation = styled(Stack)`
  padding: ${unit(4)} 0 ${unit(4)} ${unit(4.5)};
  gap: ${unit(4)};
`

const TileTitle = styled(Typography)`
  color: ${COLORS.white};
`

const TileDescription = styled(Typography)`
  color: ${COLORS.red['bright']};
`
const TileBuy = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${unit(2)};
  color: ${COLORS.white};
`

const TileBuyDescription = styled(Typography)`
  text-transform: uppercase;
`
